import script from "./SwitchHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchHelp.vue?vue&type=script&setup=true&lang=js"

import "./SwitchHelp.vue?vue&type=style&index=0&id=577dfcb8&lang=scss"

const __exports__ = script;

export default __exports__